import styled from "styled-components";
import { Typography } from "@mui/material";
import { styled as muiStyled } from "@mui/material/styles";
import Button from "components/atoms/Button";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: absolute;
  top: 50%;
  left: 50%;
  width: 464px;
  transform: translate(-50%, -50%);
  padding: 0;
  background: white;
  border-radius: 4px;
  box-shadow: 0px 11px 15px -7px rgba(0, 0, 0, 0.2),
    0px 24px 38px 3px rgba(0, 0, 0, 0.14), 0px 9px 46px 8px rgba(0, 0, 0, 0.12);
  outline: none;
`;

export const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 24px 24px 0 24px;

  h6 {
    font-size: 20px;
    font-weight: 500;
    line-height: 32px;
    letter-spacing: 0.15px;
    color: rgba(0, 0, 0, 0.87);
    margin: 0;
  }

  svg {
    cursor: pointer;
    color: rgba(0, 0, 0, 0.54);
    transition: color 0.2s;

    &:hover {
      color: rgba(0, 0, 0, 0.87);
    }
  }
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px 24px;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 8px;
  padding: 16px 24px;
  // border-top: 1px solid rgba(0, 0, 0, 0.12);
`;

export const TitleTypography = muiStyled(Typography)({
  fontSize: "20px",
  fontWeight: 400,
  lineHeight: "32px",
  letterSpacing: "0.15px",
  color: "#202224",
});

export const CancelButton = muiStyled(Button)({
  borderRadius: "4px",
  fontSize: "14px",
  fontWeight: 500,
  letterSpacing: "0.4px",
  padding: "6px 16px",
  border: "none",
  textDecoration: "underline",
  color: "#D33000",
  "&:hover": {
    backgroundColor: "transparent",
    border: "none",
    textDecoration: "underline",
  },
});

export const ConfirmButton = muiStyled(Button)({
  borderRadius: "4px",
  fontSize: "14px",
  fontWeight: 500,
  letterSpacing: "0.4px",
  padding: "6px 16px",
  backgroundColor: "#D32F2F",
  boxShadow:
    "0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12)",
  "&:hover": {
    backgroundColor: "#C62828",
    boxShadow:
      "0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12)",
  },
  "&:disabled": {
    backgroundColor: "rgba(0, 0, 0, 0.12)",
    color: "rgba(0, 0, 0, 0.26)",
  },
});
